import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';

import { SharedModule } from '../../../../core/modules/shared.module';
import { LogEntryDetailDialogComponent } from './detail.dialog.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';

const routes = [{path: 'log.entry.detail.dialog', component: LogEntryDetailDialogComponent}];

@NgModule({
  declarations: [LogEntryDetailDialogComponent],
  imports: [SharedModule, RouterModule.forChild(routes), NgxChartsModule],
  exports: [LogEntryDetailDialogComponent]
})

export class LogEntryDetailDialogModule {}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/log.entries/detail/detail.dialog.module.ts